import React, { createContext, useState, useContext } from "react";

const InAppNotificationContext = createContext({
  showInAppNotification: false,
  show: (text) => null,
  text: "",
  hide: () => null,
});

export const InAppNotificationProvider = ({ children }) => {
  const [showInAppNotification, setShowInAppNotification] = useState(false);
  const [text, setText] = useState("");

  const show = (text) => {
    setText(text);
    setShowInAppNotification(true);
  };

  const hide = () => {
    setShowInAppNotification(false);
  };

  return (
    <InAppNotificationContext.Provider
      value={{ showInAppNotification, text, show, hide }}
    >
      {children}
    </InAppNotificationContext.Provider>
  );
};

export const useInAppNotification = () => useContext(InAppNotificationContext);
